import { render, staticRenderFns } from "./Videocam.vue?vue&type=template&id=40f44e57&"
import script from "./Videocam.vue?vue&type=script&lang=js&"
export * from "./Videocam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports